export default {
  init() {
    // JavaScript to be fired on the home page
    $(window).on('scroll',function () {
      if ($(this).scrollTop()  <= 100 ){
          $(".scroll-down-arrow-inner").show();
      }else{
        $(".scroll-down-arrow-inner").fadeOut(700);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js